import { render, staticRenderFns } from "./_border.vue?vue&type=template&id=b03147d0&"
import script from "./_border.vue?vue&type=script&lang=js&"
export * from "./_border.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports